<template>
    <v-card :loading="loading">
        <v-card-title class="text-h5">
            <v-btn small icon @click="closeDialog" color="primary" class="mr-2">
                <v-icon>
                    mdi-close
                </v-icon>
            </v-btn>
            <h3>
                Update Quantity To Receive
            </h3></v-card-title
        >
        <v-divider class="ml-4 mr-5" />
        <v-card-text class="pt-6 pb-0">
            <v-form v-model="isValid"
                ><v-row>
                    <v-col cols="3">
                        <p
                            class="d-flex justify-center align-center my-0 py-0"
                            style="font-size: 25px;"
                        >
                            {{ selectedItem.qtyToReceive || 0 }}
                        </p>
                    </v-col>
                    <v-col cols="1">
                        <p
                            class="d-flex justify-center align-center my-0 py-0"
                            style="font-size: 25px;"
                        >
                            +
                        </p>
                    </v-col>
                    <v-col cols="3" class="pt-2"
                        ><v-text-field
                            type="number"
                            v-model="selectedItem.newQtyToReceive"
                            class="d-flex justify-center align-center my-0 py-0"
                            style="font-size: 25px;"
                            :rules="[
                                () => maxUpdateValue(selectedItem),
                                rules.required,
                                rules.number,
                            ]"
                    /></v-col>
                    <v-col cols="1">
                        <p
                            class="d-flex justify-center align-center my-0 py-0"
                            style="font-size: 25px;"
                        >
                            =
                        </p>
                    </v-col>
                    <v-col cols="3">
                        <p
                            class="d-flex justify-center align-center my-0 py-0"
                            style="font-size: 25px;"
                        >
                            {{
                                Number(selectedItem.qtyToReceive || 0) +
                                    Number(selectedItem.newQtyToReceive || 0)
                            }}
                        </p>
                    </v-col>
                </v-row></v-form
            >
        </v-card-text>
        <v-spacer></v-spacer>
        <v-card-actions class="pb-4">
            <v-spacer />
            <v-spacer></v-spacer>
            <v-btn
                @click="
                    updateReceiveQty(
                        Number(selectedItem.qtyToReceive || 0) +
                            Number(selectedItem.newQtyToReceive)
                    )
                "
                color="primary"
                :loading="loading"
                rounded
                :disabled="loading || !isValid"
            >
                SAVE
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapMutations } from 'vuex'
import API from '@/services/api'

export default {
    name: 'AddQtyToReceive',
    props: {
        workOrder: {
            type: Object,
            required: true,
            default: () => [],
        },
        selectedItem: {
            type: Object,
            required: true,
            default: () => [],
        },
    },
    data: () => ({
        loading: false,
        rules: {
            optionalNumber: v =>
                (isNaN(v) && v != '') || parseInt(v) > 0 || 'Invalid number',
            required: v => !!v || 'Required',
            number: v => (!isNaN(v) && Number(v) > 0) || 'Invalid number',
        },
        isValid: false,
    }),
    methods: {
        ...mapMutations(['setErrorItems']),
        closeDialog() {
            this.$emit('closeQtyReceiveDialog')
        },
        async updateReceiveQty(newValue) {
            try {
                this.selectedItem.temporalQty = newValue
                let newItem = await API.updateDeliveryTemporalQuantity({
                    workOrderId: this.workOrder.id,
                    delivery: this.selectedItem,
                })
                // replace data
                this.selectedItem.newQtyToReceive = 0
                this.selectedItem.qtyToReceive = newItem.temporalQty
                    ? newItem.temporalQty // replace qty to receive
                    : 0
                // emit
                this.$emit('replaceTemporalQty', this.selectedItem)
                this.closeDialog()
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        maxUpdateValue(item) {
            const value =
                Number(item.qtyToReceive || 0) +
                Number(item.newQtyToReceive || 0)

            if (item.qty) {
                if (value > item.qty) {
                    return `The value cannot be greater than ${Number(
                        item.qty
                    ) - Number(item.qtyToReceive || 0)}.`
                } else {
                    return true
                }
            }

            if (value > item.newQtyToReceive) {
                return `The value cannot be greater than ${Number(
                    item.newQtyToReceive
                ) - Number(item.qtyToReceive || 0)}.`
            } else {
                return true
            }
        },
    },
}
</script>
